import React, { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import LoadingStates from "@/components/LoadingStates";

interface AuthCheckProps {
	children: React.ReactNode;
}

const AuthCheck: React.FC<AuthCheckProps> = ({ children }) => {
	const { user, profile, loading } = useAuth();
	const navigate = useNavigate();

	useEffect(() => {
		if (loading) return; // Wait for auth to load

		// If user is authenticated, redirect based on role
		if (user && profile) {
			const userRole = profile.role;

			switch (userRole) {
				case "parent":
					navigate("/parent-dashboard");
					break;
				case "doula":
					// If doula hasn't completed onboarding, send to onboarding
					if (!profile.onboarding_completed) {
						navigate("/doula-onboarding");
					} else {
						navigate("/doula-dashboard");
					}
					break;
				case "admin":
					navigate("/admin-dashboard");
					break;
				default:
					// If role is unknown, stay on signup page
					break;
			}
		}
	}, [user, profile, loading, navigate]);

	// Show loading while auth is being determined
	if (loading) {
		return <LoadingStates.PageLoading />;
	}

	// If user is not authenticated, show the signup page
	if (!user) {
		return <>{children}</>;
	}

	// If user is authenticated, show loading while redirecting
	return <LoadingStates.PageLoading />;
};

export default AuthCheck;
